import React from 'react'
import { Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const Faq = () => {
    return (
        <Fragment>
            <section className="pt-[88px] lg:pt-[98px] -mt-[88px] lg:-mt-[98px] bg-[#F8F8F8] py-[80px]">
                <Container>
                    <Row className='justify-center'>
                        <Col md={8} className='text-center'>
                            <h1 className='font-medium text__64 text-Mblack mb-6'>Coming Soon</h1>
                            <p className='text__18 mb-6'>Our FAQ section is currently being prepared. In the meantime, feel free to reach out to us directly!</p>
                            <a href="#contact" className='inline-block cursor-pointer text-center font-medium text__16 text-white !py-[15px] !px-[28px] bg-Morange !border-Morange btnClass hover:bg-[#E66B00]'>
                                Contact Us
                            </a>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}

export default Faq